// extracted by mini-css-extract-plugin
export default {"form-header":"FormHeader_form-header__5Q0Rw","description":"FormHeader_description__rcHWS"};